module.exports = __webpack_public_path__ + "static/media/video-3d-animated.0c6145ca.png";